<template>
  <h1 class="header border-b-solid">Plant Tracker</h1>
</template>

<script>
export default {
  name: "the-header",
};
</script>

<style>
.header {
  @apply text-4xl;
  @apply text-gray-200;
  @apply text-center;
  @apply bg-gray-900;
  @apply w-full;
  @apply p-4;
  @apply mb-8;
  @apply border-b-2;
  @apply border-gray-800;
  @apply shadow-2xl;
}
</style>
